module.exports = __webpack_public_path__ + "static/media/landscape_1_5rule.0a38875d.jpg";